import { render, staticRenderFns } from "./PaymentMethodPage.vue?vue&type=template&id=babd8d4e&scoped=true&"
import script from "./PaymentMethodPage.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodPage.vue?vue&type=script&lang=js&"
import style0 from "./PaymentMethodPage.vue?vue&type=style&index=0&id=babd8d4e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "babd8d4e",
  null
  
)

export default component.exports